import { render, staticRenderFns } from "./FileViewerAdapter.vue?vue&type=template&id=6f00527f&scoped=true&"
import script from "./FileViewerAdapter.vue?vue&type=script&lang=ts&"
export * from "./FileViewerAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f00527f",
  null
  
)

export default component.exports